import { useEffect, useState } from "react";
import { Menu } from "../Menu";
import { Burguer } from "../Icons";
import "../../index.css";
import "./style.css";
import logo from "../../img/Logo.png";
import helpIcon from "../../img/icon/help.svg";
import logoutIcon from "../../img/icon/logout.svg";
import Diamante from '../../img/icon/Diamante.svg';
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { NiveisAcesso } from '../../constants/niveisAcesso';
import { Alert } from "react-bootstrap";

export const Sidebar = () => {
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [userName, setUserName] = useState('');
    const [dadosCredenciado, setDadosCredenciado] = useState<{ uuid?: string }>({});
    const [dadosRepresentante, setDadosRepresentante] = useState<{ uuid?: string }>({});
    const [nivelAcesso, setNivelAcesso] = useState(0);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const user = await api.get('dados-usuario');
                setUserName(user.data.nome);

                if (user.data.nome === "Administrador") {
                    setNivelAcesso(4);
                } else {
                    const nivelAcesso = await api.get('nivel-acesso');
                    setNivelAcesso(nivelAcesso.data.nivel);

                    if (nivelAcesso.data.nivel === NiveisAcesso.CREDENCIADO) {
                        const responseCredenciado = await api.get('listar-dados-credenciado');
                        setDadosCredenciado(responseCredenciado.data);
                    }

                    if (nivelAcesso.data.nivel === NiveisAcesso.REPRESENTANTE) {
                        const responseRepresentante = await api.get('listar-dados-representante');
                        setDadosRepresentante(responseRepresentante.data);
                    }
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        fetchData();
    }, []);




    const logout = () => {
        localStorage.removeItem('token')
        navigate('/')
    }

    const [showAlert, setShowAlert] = useState(false);
    const [fadeAlert, setFadeAlert] = useState(false);


    const displayAlert = () => {
        setShowAlert(true);
        setFadeAlert(false);

        setTimeout(() => {
            setFadeAlert(true);
            setTimeout(() => {
                setShowAlert(false);
            }, 500);
        }, 3500);
    };
    return (
        <>
            {showAlert && (
                <div className={`alert-container ${fadeAlert ? 'fade-out' : ''}`}>
                    <Alert variant="success" onClose={() => { setShowAlert(false); }} dismissible>
                        Link de indicação copiado com sucesso!
                    </Alert>
                </div>
            )}
            <div className={`sidebar ${isOpen ? 'open' : ''}`}>

                <button className="toggle-button" onClick={toggleSidebar}>
                    <Burguer />
                </button>

                <div className="sidebar-top">
                    <img className="logo" src={logo} alt="Logo" />
                    <div className="infos">
                        <div className="div-wrapper">
                            <p className="div">
                                <span className="text-wrapper">Usuário: <b>{userName}</b></span>
                            </p>

                            {nivelAcesso === NiveisAcesso.CREDENCIADO || nivelAcesso === NiveisAcesso.REPRESENTANTE ? (
                                <div className="div" style={{ margin: '4px', textAlign: 'center' }}>
                                    <button className="copy-button" style={{ fontSize: '12px', padding: '4px 8px', backgroundColor: '#066fdf', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => {
                                        navigator.clipboard.writeText(`${window.location.origin}/new-register?rep=${nivelAcesso === NiveisAcesso.CREDENCIADO ? dadosCredenciado.uuid : dadosRepresentante.uuid}`);
                                        displayAlert();
                                    }}>
                                        Copiar Link de Indicação
                                    </button>
                                </div>
                            ) : (
                                <a href="/planos" className="custom-link">
                                    <div className="upgrade">
                                        <img src={Diamante} />
                                        <p className="upgrade-text">Upgrade de Plano</p>
                                    </div>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
                <Menu route="/" />
                <div className="sidebar-bottom">
                    <a href="https://wa.me/5541997773357?text=Ol%C3%A1%2C+preciso+de+suporte%21" className="div">
                        <img className="img" src={helpIcon} alt="Suporte" />
                        <div className="link-sidebar">Suporte</div>
                    </a>
                    <a href="#" onClick={logout} className="div">
                        <img className="img" src={logoutIcon} alt="Sair" />
                        <div className="link-sidebar">Sair</div>
                    </a>
                </div>
            </div>
        </>

    );


};
